import axios from 'axios';
import qs from 'qs';
import { environments } from '@shared/config';

import Router from 'next/router';

const CancelToken = axios.CancelToken;
export const source = CancelToken.source();

/*
##################################################
######## Axios main configuration file... ########
##################################################
*/

export const getAccessToken = name => {
    var cookieArray = decodeURIComponent(document.cookie).split(';');
    for(var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i]?.trim();
        if (cookie.indexOf(`${name}=`) == 0) {
            return cookie.substring(name.length + 1, cookie.length);
        }
    }
    return '';
};

const setCookie = (name, value) => {
    var d = new Date();
    var expires = `expires=${d.toISOString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
};

const removeAccessToken = () => {
    setCookie('access_token', '');
};

/* =============================================== */
/* == The following function skips falsy values == */
/* === as query parameters in the get requests === */
/* =============================================== */
const filterNonNull = obj =>  Object.fromEntries(Object.entries(obj).filter(([ _k, v ]) => v));
/* =============================================== */

const sessionHttpModule = axios.create({
    baseURL: environments.api_endpoint,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
});

const httpModule = axios.create({
    baseURL: environments.api_endpoint,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    },
    cancelToken: source.token,
    paramsSerializer: params => {
        return qs.stringify(filterNonNull(params), {
            arrayFormat: 'comma'
        });
    }
});

const httpModuleFormData = axios.create({
    baseURL: environments.api_endpoint,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
    },
    cancelToken: source.token
});

/* Interceptors configuration */
sessionHttpModule.interceptors.request.use(config => {
    return config;
}, error => {
    return Promise.reject(error);
});

httpModule.interceptors.request.use(config => {
    const access_token = getAccessToken('access_token');
    if (access_token !== '') {
        config.headers.Authorization = `Bearer ${access_token}`;
    }

    return config;
}, error => {
    return Promise.reject(error);
});

httpModule.interceptors.response.use(response => {
    return response;
}, error => {
    if (401 === error.response.status || 403 === error.response.status) {
        removeAccessToken();
        Router.replace('/session');
        if (typeof window !== 'undefined') {
            window.location.pathname = '/session';
            window.location.reload();
        }
    } else {
        return Promise.reject(error);
    }
});

httpModuleFormData.interceptors.request.use(config => {
    const access_token = getAccessToken('access_token');
    if (access_token !== '') {
        config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

httpModuleFormData.interceptors.response.use(response => {
    return response;
}, error => {
    if (401 === error.response.status || 403 === error.response.status) {
        removeAccessToken();
        Router.replace('/session');
        if (typeof window !== 'undefined') {
            window.location.pathname = '/session';
            window.location.reload();
        }
    } else {
        return Promise.reject(error);
    }
});

export {
    sessionHttpModule,
    httpModule,
    httpModuleFormData
};
